"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const styled_1 = __importDefault(require("../utils/styled"));
const Icon_1 = require("../Icon");
const Container = styled_1.default("nav")(({ theme }) => ({
    label: "breadcrumbs",
    color: theme.color.text.action,
    "& > *": {
        verticalAlign: "middle",
    },
}));
const Slash = styled_1.default("span")(({ theme }) => ({
    margin: `0 ${theme.space.content}px`,
    color: theme.color.text.lightest,
}));
const addCaret = (item) => React.cloneElement(item, { icon: Icon_1.CaretLeftIcon, iconLeft: true });
/**
 * Intersperse slashes between the children (`<Breadcrumb />` elements)
 * Curried first argument is necessary to give unique auto-incrementing
 *  keys to the slash elements.
 */
const intersperseSlashes = (index) => ([head, ...tail]) => head && tail.length
    ? [head, React.createElement(Slash, { key: `divider-${index}` }, "/"), ...intersperseSlashes(index + 1)(tail)]
    : [head];
const Breadcrumbs = props => {
    const items = React.Children.toArray(props.children);
    return (React.createElement(Container, Object.assign({ "aria-label": "Breadcrumb" }, props), items.length === 1 ? [addCaret(items[0])] : intersperseSlashes(0)(items)));
};
exports.default = Breadcrumbs;
//# sourceMappingURL=Breadcrumbs.js.map